import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../store/hooks';

export default function useIsPartnerDeactivated(): boolean {
  const isPartnerDeactivated = useStoreState(state => state.partner.isPartnerDeactivated);
  const isLoaded = useStoreState(state => state.partner.status === 'ready');
  const fetchPartnerInfo = useStoreActions(actions => actions.partner.fetchPartnerInfo);

  useEffect(() => {
    fetchPartnerInfo();
  }, [fetchPartnerInfo]);

  return !isLoaded || isPartnerDeactivated;
}
